import React from 'react';

import { block } from 'bem-cn';

import { LANGUAGES } from '../../constants';
import useLocalizedStrings from '../../hooks/useLocalizedStrings';
import { withStopPropagation } from '../../utils';

import './pending-pion.scss';

const b = block('pending-pion');

export const translations = {
  [LANGUAGES.EN]: {
    title: 'FETCHING INFORMATION',
    subtitle: "We will let you know when it's done",
    stopButtonTitle: 'Stop',
  },
  [LANGUAGES.SV]: {
    title: 'HÄMTAR INFORMATION',
    subtitle: 'Vi meddelar dig när det är klart',
    stopButtonTitle: 'Stoppa',
  },
};

type PendingPionPropsType = {
  onPionClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onButtonClick: (event: any) => void;
  lang: string;
};

const PendingPion = ({
  onPionClick = () => {},
  onButtonClick = () => {},
  lang,
}: PendingPionPropsType) => {
  const strings = useLocalizedStrings(translations, lang);

  return (
    <div className={b()} onClick={onPionClick}>
      <div className={b('header')}>
        <div className={b('header-block')}>
          <div className={b('icon')} />
          <h1 className={b('title')}>{strings.title}</h1>
        </div>
        <button
          className={b('header-button')}
          onClick={withStopPropagation(onButtonClick)}
        >
          {strings.stopButtonTitle}
        </button>
      </div>
      <div className={b('content')}>{strings.subtitle}</div>
    </div>
  );
};

export default PendingPion;
